import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-ums-version",
  "use": "icon-ums-version-usage",
  "viewBox": "0 0 36.3 36.3",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 36.3 36.3\" id=\"icon-ums-version\">\n  <path id=\"icon-ums-version_路径_2976\" data-name=\"路径 2976\" d=\"M75.039,56.889a18.15,18.15,0,1,1-18.15,18.15A18.15,18.15,0,0,1,75.039,56.889ZM71.27,67.874H66.018l6.139,16.24H77.6l6.026-16.24h-5.1l-3.6,11.686L71.273,67.874Z\" transform=\"translate(-56.889 -56.889)\" fill=\"\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/ums-version.svg
// module id = 7RVg
// module chunks = 19